// Editable checklist data - sorted by priority, top 3 shown per competency

export interface ChecklistDataItem {
  id: string;
  text: string;
  priority: number; // 1 = highest priority
}

export interface CompetencyChecklistData {
  icon: string;
  items: ChecklistDataItem[];
}

export const checklistPageConfig = {
  sectionLabel: "Your Action Plan",
  title: "Your Personalised Checklist",
  subtitle: "Based on your choices in the game, here's what we recommend trying differently at work.",
};

export const checklistData: Record<string, CompetencyChecklistData> = {
  "Goal Setting": {
    icon: "🎯",
    items: [
      {
        id: "gs1",
        text: "Define SMART objectives for each project milestone",
        priority: 1,
      },
      { id: "gs2", text: "Create visual progress trackers for team visibility", priority: 2 },
      { id: "gs3", text: "Schedule weekly goal review sessions", priority: 3 },
      { id: "gs4", text: "Break annual goals into quarterly milestones", priority: 4 },
      { id: "gs5", text: "Align individual goals with team objectives", priority: 5 },
      { id: "gs6", text: "Document lessons learned after each goal cycle", priority: 6 },
      { id: "gs7", text: "Share goal progress in team stand-ups", priority: 7 },
      { id: "gs8", text: "Celebrate small wins to maintain momentum", priority: 8 },
    ],
  },
  Delegation: {
    icon: "📋",
    items: [
      { id: "d1", text: "Match tasks to team members' strengths and growth areas", priority: 1 },
      { id: "d2", text: "Provide clear context and expected outcomes for each task", priority: 2 },
      { id: "d3", text: "Establish check-in points without micromanaging", priority: 3 },
      { id: "d4", text: "Let team members choose their own approach", priority: 4 },
      { id: "d5", text: "Provide resources and support before handing off", priority: 5 },
      { id: "d6", text: "Give feedback after task completion, not during", priority: 6 },
      { id: "d7", text: "Recognize and celebrate ownership behaviours", priority: 7 },
      { id: "d8", text: "Gradually increase task complexity over time", priority: 8 },
    ],
  },
  "Giving Feedback": {
    icon: "💬",
    items: [
      { id: "f1", text: "Use the SBI model (Situation, Behavior, Impact)", priority: 1 },
      { id: "f2", text: "Balance constructive criticism with positive recognition", priority: 2 },
      { id: "f3", text: "Schedule regular one-on-one feedback sessions", priority: 3 },
      { id: "f4", text: "Ask for permission before giving unsolicited feedback", priority: 4 },
      { id: "f5", text: "Follow up on previous feedback to track progress", priority: 5 },
      { id: "f6", text: "Create informal moments for quick positive reinforcement", priority: 6 },
    ],
  },
  "Conflict Management": {
    icon: "⚔️",
    items: [
      { id: "c1", text: "Address conflicts early before they escalate", priority: 1 },
      { id: "c2", text: "Practice active listening to understand all perspectives", priority: 2 },
      { id: "c3", text: "Focus on interests rather than positions", priority: 3 },
      { id: "c4", text: "Separate the person from the problem", priority: 4 },
      { id: "c5", text: "Use 'I' statements instead of 'you' accusations", priority: 5 },
      { id: "c6", text: "Identify common ground before discussing differences", priority: 6 },
      { id: "c7", text: "Establish ground rules for difficult conversations", priority: 7 },
      { id: "c8", text: "Document agreements and follow-up actions", priority: 8 },
      { id: "c9", text: "Build preventive team norms to reduce friction", priority: 9 },
      { id: "c10", text: "Seek mediation when direct resolution stalls", priority: 10 },
    ],
  },
};
